import axios from "axios";
import Cookies from "js-cookie";
import { installAuthInterceptor } from "../utils/authSession";

// Dedicated axios instance for the authenticated V2 Course APIs (/api/v2/*).
//
// Why a separate instance rather than a global default or interceptor: the app has no
// global axios configuration today, and adding one would also apply to the V1 calls that
// LMS-Client still makes (and, in the shared-bundle sense, to every other axios usage).
// axios.create() gives us a scoped client, so existing V1 behaviour is untouched.
//
// The token is read per request (not captured once at module load) so that a login,
// logout, or token refresh during the session is picked up immediately - the same
// Cookies.get("authToken") source the already-authenticated services use, e.g.
// lessonsURLServices.js and GetCompletedLessonIDs.js.
const v2Axios = axios.create();

v2Axios.interceptors.request.use((config) => {
	const authToken = Cookies.get("authToken");
	if (authToken) {
		config.headers = config.headers || {};
		config.headers.Authorization = `Bearer ${authToken}`;
	}
	return config;
});

// a 401 on an authenticated request ends the session (central logout)
installAuthInterceptor(v2Axios);

export default v2Axios;
